/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Node } from "@tiptap/core";
import EmbedNodeView from "./components/EmbedNodeView";
import { DEFAULT_ATTRIBUTES, EXTENSION_NAME } from "./constants";

export const Embed = /* @__PURE__ */ Node.create({
  name: EXTENSION_NAME,
  content: "",
  marks: "",
  group: "block",
  selectable: true,
  atom: true,
  draggable: true,

  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "iframe",
      },
    };
  },

  addAttributes() {
    return {
      width: {
        default: DEFAULT_ATTRIBUTES.width,
      },
      src: {
        default: DEFAULT_ATTRIBUTES.src,
      },
      allowfullscreen: {
        default: DEFAULT_ATTRIBUTES.allowfullscreen,
      },
      rawSrc: {
        default: DEFAULT_ATTRIBUTES.rawSrc,
      },
      maxWidth: {
        default: DEFAULT_ATTRIBUTES.maxWidth,
      },
      minWidth: {
        default: DEFAULT_ATTRIBUTES.minWidth,
      },
      aspectRatio: {
        default: DEFAULT_ATTRIBUTES.aspectRatio,
      },
      frameborder: {
        default: DEFAULT_ATTRIBUTES.frameborder,
      },
      caption: {
        default: DEFAULT_ATTRIBUTES.caption,
      },
      align: {
        default: DEFAULT_ATTRIBUTES.align,
      },
    };
  },
});

export const EmbedNodeMapping = {
  [EXTENSION_NAME]: EmbedNodeView,
};
